<template>
  <figure class="device-frame group relative">
    <div class="frame-halo pointer-events-none absolute inset-x-4 bottom-0 h-20 rounded-full blur-3xl sm:inset-x-12 sm:h-24"></div>

    <div class="frame-shell relative rounded-[1.7rem] p-1.5 sm:rounded-[2.35rem] sm:p-3">
      <div
        class="overflow-hidden rounded-[1.4rem] border border-[var(--ce-border)] bg-[var(--ce-surface)] shadow-[var(--ce-shadow-large)] sm:rounded-[1.9rem]"
      >
        <div
          v-if="chrome"
          class="flex h-11 items-center justify-between border-b border-[var(--ce-border)] bg-[var(--ce-glass-strong)] px-3 backdrop-blur-xl sm:h-12 sm:px-5"
        >
          <div class="flex gap-1.5">
            <span class="h-2.5 w-2.5 rounded-full bg-rose-400/70"></span>
            <span class="h-2.5 w-2.5 rounded-full bg-amber-400/70"></span>
            <span class="h-2.5 w-2.5 rounded-full bg-emerald-400/70"></span>
          </div>

          <span
            v-if="label"
            class="max-w-[11rem] truncate rounded-full border border-[var(--ce-border)] bg-[var(--ce-surface)] px-2.5 py-1.5 text-[8px] font-semibold uppercase tracking-[0.10em] text-[var(--ce-muted)] sm:max-w-none sm:px-3 sm:text-[9px] sm:tracking-[0.12em]"
          >
            {{ label }}
          </span>

          <span class="h-7 w-7"></span>
        </div>

        <div
          :class="[
            'frame-content relative overflow-hidden',
            aspectRatio === 'auto' ? 'frame-content-auto' : ''
          ]"
          :style="aspectRatio === 'auto' ? undefined : { aspectRatio }"
        >
          <div class="frame-glow pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full blur-3xl"></div>

          <div class="relative h-full w-full">
            <slot />
          </div>
        </div>

        <figcaption
          v-if="caption"
          class="border-t border-[var(--ce-border)] px-5 py-3 text-xs leading-5 text-[var(--ce-muted)]"
        >
          {{ caption }}
        </figcaption>
      </div>
    </div>
  </figure>
</template>

<script setup>
defineProps({
  caption: { type: String, default: '' },
  label: { type: String, default: 'ControlEase' },
  chrome: { type: Boolean, default: true },
  aspectRatio: { type: String, default: '16 / 10' }
})
</script>

<style scoped>
.frame-shell {
  background:
    linear-gradient(
      135deg,
      rgba(124, 58, 237, 0.18),
      rgba(255, 255, 255, 0.04),
      rgba(192, 38, 211, 0.10)
    );
  border: 1px solid var(--ce-border);
  box-shadow:
    var(--ce-shadow-soft),
    inset 0 1px 0 rgba(255, 255, 255, 0.10);
  transition:
    transform 450ms ease,
    box-shadow 450ms ease;
}

.device-frame:hover .frame-shell {
  transform: translateY(-3px);
  box-shadow: var(--ce-shadow-large);
}

.frame-halo,
.frame-glow {
  background:
    linear-gradient(
      90deg,
      rgba(124, 58, 237, 0.16),
      rgba(192, 38, 211, 0.12)
    );
}

.frame-content {
  min-height: 12rem;
}

.frame-content-auto {
  min-height: 0;
  overflow: visible;
}

@media (hover: none) {
  .device-frame:hover .frame-shell {
    transform: none;
  }
}

@media (max-width: 420px) {
  .frame-shell {
    box-shadow:
      0 10px 30px rgba(48, 30, 62, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.08);
  }
}

</style>
